module.exports = __webpack_public_path__ + "img/Font 04.6dd82157.jpg";